import { Anchor, Breadcrumbs, Card, Grid, Text } from '@mantine/core';
import { useLocation, useNavigate, useParams } from 'react-router';

import Metadata from '../../components/Metadata';
import SegmentNewForm from '../../components/Segments/SegmentNewForm';
import { Page } from '../../constants/pageTitles';

const page = `${Page['segment']}`;

const SegmentsNewPage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { accountId, domainId } = useParams();

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/segments` },
    { title: 'New' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <SegmentNewForm
              onSave={() => navigate(location.pathname.replace(`/segments/new`, '/segments'))}
              onBack={() => navigate(-1)}
            />
          </Card>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default SegmentsNewPage;
